import { Stack } from "@mui/material";
import { isMobile } from "react-device-detect";
import { LargeContentBox } from "../../components/common";
import { Form } from "./components/form";

export function MyfamilyForDash({ open, onClose }: any) {
  return (
    <>
      {isMobile ? (
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Form />
        </Stack>
      ) : (
        <LargeContentBox>
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Form />
          </Stack>
        </LargeContentBox>
      )}
    </>
  );
}
